const state = {
    subscriptionsInfo: null,
    subscriptionsActivity: null,
    subscriptionsTeam: null,
    showNewTeamModal: false,
    showUpdateTeamModal: false,
    updateTeamMemberDetails: {},
    confirmationModal: false,
    confirmationType: null,
};

const mutations = {
    SET_SUBSCRIPTIONS_INFO: (state, subscriptionsInfo) => {
        state.subscriptionsInfo = subscriptionsInfo;
    },
    SET_SUBSCRIPTIONS_ACTIVITY: (state, subscriptionsActivity) => {
        state.subscriptionsActivity = subscriptionsActivity;
    },
    SET_SUBSCRIPTIONS_TEAM: (state, subscriptionsTeam) => {
        state.subscriptionsTeam = subscriptionsTeam;
    },
    SET_SHOW_NEW_TEAM_MODAL: (state, show) => {
        state.showNewTeamModal = show;
    },
    SET_SHOW_UPDATE_TEAM_MODAL: (state, show) => {
        state.showUpdateTeamModal = show;
    },
    SET_UPDATE_TEAM_MEMBER_DETAILS: (state, item) => {
        state.updateTeamMemberDetails = item;
    },
    SET_CONFIRMATION_MODAL: (state, confirmationModal) => {
        state.confirmationModal = confirmationModal;
    },
    SET_CONFIRMATION_TYPE: (state, confirmationType) => {
        state.confirmationType = confirmationType;
    },
};

const getters = {
    subscriptionsInfo: (state) => state.subscriptionsInfo,
    subscriptionsActivity: (state) => state.subscriptionsActivity,
    subscriptionsTeam: (state) => state.subscriptionsTeam,
    showNewTeamModal: (state) => state.showNewTeamModal,
    showUpdateTeamModal: (state) => state.showUpdateTeamModal,
    updateTeamMemberDetails: (state) => state.updateTeamMemberDetails,
    confirmationType: (state) => state.confirmationType,
    confirmationModal: (state) => state.confirmationModal,
};

const subscriptions = {
    state,
    getters,
    mutations,
};

export default subscriptions;